export class Mensaje{
    NumMsj: number;
    TxtMsj: string;
    TxtMsj2: string;
    msj: string;
    id: number;
    dsc: string;
}
